<template>
  <div>
      <DxForm   
                :items="items"
                :label-location="labelLocation"
                v-for="(key,index) in lineItems.items"
                :form-data="lineItems.items"                             
                >
        <template #form-item="{ data: item }">
            <div>   
                <div v-if="item.editorType=='dxTextBox'" >
                 
                <DxTextBox
                                          
                    v-model="lineItems.items[index][item.dataField]"                    
                    value-change-event="keyup"
                    @value-changed="inputChanged(index,item.dataField)"/>
                    
                </div>
                <div v-if="item.itemType == 'button'">
                    
                    
                </div>
            </div> 
        </template>
        <template #form-button="{ data: item }">
            <DxButton
                icon="trash"            
                @click="removeLine(index)"
            />
        </template>   
            
                
    </DxForm>
    
    <div class="line-add-button">
        <DxButton
            
            text="Add Line"
            type="normal"
            icon="plus"
            styling-mode="contained"
            @click="addLine($event)"
        />
    </div>
  </div>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxLabel
} from 'devextreme-vue/form';

import DxTextBox from 'devextreme-vue/text-box'; 
import DxButton from 'devextreme-vue/button';
import {getLineItemLayoutDef} from '../Pages/Builder/base.js';

export default {
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
            required: true
        },
        
        defaultData:
        {
            type: Array,
            default: [],
        },
        fname:String,
        modRoute:String,
    },
    components: {
        DxForm,
        DxSimpleItem,
        DxButton,
        DxLabel,
        DxTextBox
    },
    data:function()
    {
        return {
                formData:{},
                formDataArray:[],
                LineCount:2,
                labelLocation: 'top',
                lineItems:{items:[]},
                items:[],
                items2:[{
                    itemType: "group",
                    cssClass: "group-item",
                    colCount: 'auto',                
                    items: [{
                        dataField: "FirstName",
                        editorType: "dxTextBox",
                        editorOptions:
                        {
                            width:500,
                            
                        },                        
                        cssClass: "someclass",
                        template:"form-item"
                    },
                    {
                        dataField: "LastName",
                        editorType: "dxTextBox",
                        cssClass: "someclass",
                        template:"form-item"
                        
                    },
                    {    
                        dataField: "State",
                        editorType: "dxTextBox",
                        cssClass: "someclass",
                        template:"form-item"
                    },
                    {
                        dataField: "City",   
                        cssClass: "someclass",
                        template:"form-item"
                    },
                    {
                        template:"form-button",
                        cssClass: "deleteCell",
                    }
                    ],
                }],
                
                address: {
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    province: '',
                    postal_code: ''
                }            
            }
    },
    methods: {
            
            inputChanged(indx,key) {
                
                 //console.log("hjjhds");
                 //this.formData.name="hhh";
                 //console.log(this.modelValue);
                
                /* let ab = {[key]: this.formData[key+indx]} ;
                if(this.modelValue[indx] == null)
                this.modelValue[indx] = ab; 
                else
                this.modelValue[indx][key] = this.formData[key+indx];  */
                
                //console.log(this.modelValue);
                
                this.$emit('update:modelValue', this.lineItems);
                
                
                
            },
            removeLine(index)
            {
                //this.LineCount--;
                if (index > -1) {
                    /* let obj = this.getNewObj();
                    for (let [key, val] of Object.entries(obj)) {
                        
                        //console.log([key]+(index));
                        this.formData[[key]+(index)] = val;
                    }    */
                    this.lineItems.items.splice(index, 1);
                }
                
            },
            addLine()
            {  
                this.lineItems.items.push(this.getNewObj());   
            },
            getNewObj()
            {   
                let arr = this.items[0].items;
                var object = arr.reduce(
                    (obj, item) => Object.assign(obj,  (( "dataField" in item ) &&{  [item.dataField]: "" })), {});

                return object;
            },
            getFormDef(fname)
            {
                
                getLineItemLayoutDef(this.modRoute,fname,false).then(response => {
                    
                    //console.log("hh"); 
                    //console.log(response.data);
                    this.items = Object.values(response.data);
                    
                    
                    //set blank first row
                    if(this.lineItems.items.length < 1) {                
                        this.lineItems.items[0]= this.getNewObj();
                    }
                });
                
            }
            
        },
        created: function()
        {
            

            //get form data fpr line item
            this.getFormDef(this.fname);

            //this.lineItems.itm = this.modelValue;

            
            //console.log(this.modelValue);
            //set data in form
            /* this.modelValue.forEach((value,index ) => {
                
                 for (let [key, val] of Object.entries(value)) {
                    
                    this.formData[[key]+(index+1)] = val;
                }
                                    
            }); */
            
            /* //set blank first row
            if(this.modelValue.length < 1) {                
                this.modelValue[0]= this.getNewObj();
            } */
            
            //filter

        },
        computed: {
            
        },
    mounted() {
            
        document.querySelectorAll('.someclass').forEach(item => {
            item.addEventListener('change', event => {
                //console.log(item.apple);
                var inputNodes = item.getElementsByTagName('INPUT');
                for(var i = 0; i < inputNodes.length; ++i){
                    var inputNode = inputNodes[i];
                    if(inputNode.type == 'text') {
                        //Do whatever you want
                        //console.log(inputNode.apple);
                    }
                }
            })
        })
    },
}
</script>

<style>
.line-add-button
{
    margin-top: 5px;
}
.deleteCell
{
    margin-top: auto;
    margin-right: auto;
    margin-left: auto;
}

.group-item 
> .dx-field-item-content
> .dx-form-group
> .dx-form-group-content
> .dx-layout-manager
> .dx-widget
> .dx-box-flex
> .dx-item
> .dx-item-content
> .dx-item
{
    flex: initial  !important;
} 

</style>